export default "__VITE_ASSET__df8de6fc__"